import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { en } from './en';
import { ko } from './ko';
import { FALLBACK_LANGUAGE } from './languages';
import { zh } from './zh';
import { countryLanguage, toLanguage } from '../utils/app-language';
import { isRunningInNativeApp, native } from '../utils/native-host';

const getNativeInfo = (): { locale?: string; storeCountry?: string } | null => {
  if (typeof window === 'undefined') return null;
  return ((window as unknown as Record<string, unknown>)
    .__MUZLY_DEVICE_INFO__ ?? null) as {
    locale?: string;
    storeCountry?: string;
  } | null;
};

const nativeAppDetector = {
  name: 'nativeApp',
  lookup: (): string | undefined =>
    // 네이티브 셸과 같은 규칙으로 읽는다(`resolveAppLanguage`): 스토어 국가(한국 → ko,
    // 중국 → zh, 그 밖 → en)가 먼저고, 국가를 모르면(1.0.2 이전 셸) 기기 로케일
    // (`zh_CN`·`zh-Hans-CN` → `zh`)이다. 둘 다 모르면 감지 실패로 두어 `fallbackLng` 이 정한다.
    countryLanguage(getNativeInfo()?.storeCountry) ??
    toLanguage(getNativeInfo()?.locale) ??
    undefined,
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(nativeAppDetector);

// 네이티브 셸의 문구(종료 확인·알림 채널)가 웹에서 고른 말을 따르게 알린다. **init 전에**
// 단다 — init 이 감지해 정한 첫 언어도 이 이벤트로 나가야, 사용자가 말을 바꾸기 전까지
// 네이티브가 기기 로케일로 남지 않는다. 브라우저·admin·landing 에서는 아무것도 안 한다.
i18n.on('languageChanged', (language) => {
  if (isRunningInNativeApp()) {
    native.notify('languageChanged', { language });
  }
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ko: { translation: ko },
      zh: { translation: zh },
    },
    fallbackLng: FALLBACK_LANGUAGE,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'nativeApp'],
      lookupLocalStorage: 'muzly_language',
      caches: ['localStorage'],
    },
  });

export { FALLBACK_LANGUAGE, LANGUAGES } from './languages';
export type { Language } from './languages';

export { i18n };
